import { Product } from '../types';
import { productImageMap } from './productImages';

export const products: Product[] = [
  // 软件系统类
  {
    id: 'library-management-system',
    name: 'Smart Library Management Platform',
    description: 'Comprehensive library cluster management system with minimalist interaction design and full-function integration, enabling intelligent management, convenient services, and data-driven decision-making.',
    category: 'software',
    features: [
      'Multi-library cluster management',
      'Real-time inventory tracking',
      'Advanced reporting and analytics',
      'User management and authentication',
      'Integration with RFID systems',
      'Big data visualization dashboard',
      'Mobile app support'
    ],
    specifications: {
      'Platform': 'Web-based, Cloud-ready',
      'Database': 'MySQL/PostgreSQL',
      'API': 'RESTful API with OAuth 2.0',
      'Deployment': 'On-premise or Cloud',
      'Languages': 'Multi-language support',
      'Integration': 'Full RFID ecosystem integration'
    },
    image: '/images/products/smart-library-management-platform.png'
  },
  {
    id: 'opac-search-system',
    name: 'OPAC Search System',
    description: 'Advanced OPAC search system that serves as a key hub for library announcements and personal account access, with convenient book search capabilities and borrowing status checking.',
    category: 'software',
    features: [
      'Comprehensive book search functionality',
      'Personal account management',
      'Library announcements display',
      'Borrowing status tracking',
      'Popular search terms display',
      'Book category browsing',
      'Mobile-responsive design'
    ],
    specifications: {
      'Search Engine': 'Advanced indexing system',
      'Response Time': '< 200ms',
      'Concurrent Users': '1000+',
      'Languages': '20+ languages',
      'Interface': 'Touch-screen optimized',
      'Integration': 'Smart Library Platform'
    },
    image: '/images/products/query-terminal.png'
  },
  {
    id: 'backend-management-system',
    name: 'Backend Management System',
    description: 'Simplified and minimalist backend management system with clear data presentation, streamlined functions for straightforward operation, and comprehensive library status monitoring.',
    category: 'software',
    features: [
      'Minimalist interface design',
      'Real-time data statistics',
      'Quick function shortcuts',
      'Intuitive navigation',
      'One-step operations',
      'Clear data visualization',
      'Administrator-friendly design'
    ],
    specifications: {
      'Interface': 'Web-based admin panel',
      'Data Processing': 'Real-time analytics',
      'User Management': 'Role-based access control',
      'Reporting': 'Automated report generation',
      'Security': 'Multi-layer authentication',
      'Deployment': 'Cloud or on-premise'
    },
    image: '/images/products/backend-management-system.png'
  },
  {
    id: 'library-big-data-system',
    name: 'Library Big Data System',
    description: 'Comprehensive big data platform reflecting library status with book circulation rates, collection analytics, new book recommendations, and borrowing rankings for both readers and administrators.',
    category: 'software',
    features: [
      'Book circulation rate analysis',
      'Real-time borrowing statistics',
      'Collection size monitoring',
      'New book recommendation engine',
      'Library announcements management',
      'Borrowing rankings display',
      'Data-driven insights'
    ],
    specifications: {
      'Data Processing': 'Real-time big data analytics',
      'Visualization': 'Interactive dashboards',
      'Storage': 'Distributed data warehouse',
      'Analytics': 'AI-powered insights',
      'API': 'RESTful data services',
      'Performance': 'High-throughput processing'
    },
    image: '/images/products/library-big-data-system.png'
  },
  {
    id: 'mobile-inventory-system',
    name: 'Mobile Inventory System',
    description: 'Efficient mobile inventory system for stocktaking and locating missing books, freeing librarians from routine tasks to engage in community activities and lectures.',
    category: 'software',
    features: [
      'Efficient stocktaking capabilities',
      'Missing book location tracking',
      'Mobile cart integration',
      'Real-time inventory updates',
      'Barcode and RFID scanning',
      'Automated reporting',
      'Workflow optimization'
    ],
    specifications: {
      'Platform': 'Mobile and desktop compatible',
      'Scanning': 'RFID and barcode support',
      'Connectivity': 'WiFi and 4G support',
      'Battery Life': 'All-day operation',
      'Data Sync': 'Real-time synchronization',
      'Reporting': 'Automated inventory reports'
    },
    image: '/images/products/mobile-inventory-system.png'
  },

  // 智能终端设备类 - 基于PDF手册的详细信息，使用现有图片
  {
    id: 'self-service-borrowing-smart',
    name: 'Self-Service Borrowing Machine (Smart Version)',
    description: 'High-quality crafted self-service machine with comprehensive hardware support, capable of handling all mainstream borrowing methods with sleek design and intelligent software-hardware integration.',
    category: 'hardware',
    features: [
      'All mainstream borrowing methods support',
      'High-definition LCD touchscreen display',
      'Intelligent software-hardware integration',
      'Universal wheels for mobility',
      'Tempered glass and Formica construction',
      'RFID multi-book processing',
      'User-friendly interface design'
    ],
    specifications: {
      'Model': 'TS180S-GP',
      'Dimensions': '600×485×1565mm',
      'Material': 'Sheet Metal + Acrylic + Tempered Glass + Formica',
      'Screen': '21.5-inch Touchscreen',
      'Mobility': 'Universal wheels included',
      'RFID': 'Multi-book simultaneous processing',
      'Power': 'AC 220V with UPS backup'
    },
    image: '/images/products/self-service-borrowing-smart.png'
  },
  {
    id: 'self-service-borrowing-simple',
    name: 'Self-Service Borrowing Machine (Simplified Version)',
    description: 'Simplified yet elegant self-service machine with minimalist design, supporting mainstream card-based borrowing and returning processes with high-definition display.',
    category: 'hardware',
    features: [
      'Mainstream card-based borrowing support',
      'Sleek and minimalist design',
      'High-definition LCD display',
      'Effortless book operations',
      'Quality sheet metal construction',
      'Space-efficient footprint',
      'Cost-effective solution'
    ],
    specifications: {
      'Model': 'TS180',
      'Dimensions': '515×450×1529mm',
      'Material': 'Sheet Metal + Tempered Glass',
      'Screen': '21.5-inch Touchscreen',
      'Authentication': 'Card-based systems',
      'Installation': 'Fixed floor mounting',
      'Power': 'AC 220V'
    },
    image: '/images/products/self-service-kiosk.jpg'
  },
  {
    id: 'uhf-rfid-gate',
    name: 'UHF RFID Security Gate',
    description: 'Industrial control system equipped smart gate with big data integration, real-time people counting, and comprehensive book detection with audible and visual alarms.',
    category: 'hardware',
    features: [
      'Industrial control system',
      'Real-time people counting',
      'RFID tag detection',
      'Audible and visual alarms',
      'Touch screen configuration',
      'Backend system integration',
      'Entry/exit statistics display'
    ],
    specifications: {
      'Model': 'MJ120',
      'Dimensions': '1484×370×62mm',
      'Material': 'Sheet Metal + Aluminum + Acrylic',
      'Screen': '10-inch Touch Screen',
      'RFID': 'UHF frequency band',
      'Detection': 'Real-time tag monitoring',
      'Connectivity': 'Ethernet and WiFi'
    },
    image: '/images/products/rfid-security-gate.jpg'
  },
  {
    id: 'hf-rfid-gate',
    name: 'HF RFID Security Gate',
    description: 'High-frequency RFID smart gate with big data system integration, real-time people counting, and essential security features for smart library operations.',
    category: 'hardware',
    features: [
      'High-frequency RFID detection',
      'Real-time people counting',
      'Big data system integration',
      'Audible and visual alarms',
      'Administrator notifications',
      'Essential security component',
      'Reliable tag detection'
    ],
    specifications: {
      'Model': 'MJ121-p',
      'Dimensions': '1686×635×120mm',
      'Material': 'Sheet Metal + Acrylic',
      'Screen': 'Optional display',
      'RFID': 'High-frequency (HF) band',
      'Installation': 'Floor or wall mounted',
      'Power': 'AC 220V with backup'
    },
    image: '/images/products/hf-rfid-gate.png'
  },
  {
    id: 'librarian-workstation-allinone',
    name: 'Librarian Workstation (All-in-One)',
    description: 'Dedicated workstation designed for library staff daily tasks with powerful integrated RFID reader/writer capable of handling multiple books simultaneously and supporting tag conversion.',
    category: 'hardware',
    features: [
      'Powerful integrated RFID reader/writer',
      'Multiple books simultaneous processing',
      'Tag conversion support',
      'Reader card operations',
      'Daily task optimization',
      'Staff-friendly interface',
      'High-quality construction'
    ],
    specifications: {
      'Model': 'TS120S',
      'Dimensions': '550×456×405mm',
      'Material': 'Sheet Metal + Tempered Glass',
      'Screen': '21.5-inch Touch Screen',
      'RFID': 'Multi-book processing capability',
      'Functions': 'Tag conversion and card operations',
      'Connectivity': 'USB and Ethernet'
    },
    image: productImageMap['librarian-workstation'].image
  },
  {
    id: 'self-service-card-kiosk',
    name: 'Self-Service Borrowing, Returning & Card-Issuing Kiosk',
    description: 'Multifunctional all-in-one machine providing borrowing, returning, and self-service card issuance with facial recognition capabilities and high-quality construction.',
    category: 'hardware',
    features: [
      'All-in-one multifunctionality',
      'Self-service card issuance',
      'Facial recognition support',
      'Borrowing and returning services',
      'High-quality sheet metal construction',
      'Complete hardware support',
      'Advanced authentication methods'
    ],
    specifications: {
      'Model': 'BY008',
      'Dimensions': '477×730×1718mm',
      'Material': 'Sheet Metal + Tempered Glass + Acrylic',
      'Screen': '21.5-inch Touch Screen',
      'Authentication': 'Facial recognition enabled',
      'Functions': 'Borrowing + Returning + Card issuance',
      'Installation': 'Floor standing'
    },
    image: '/images/products/self-registration-terminal.png'
  },
  {
    id: 'mini-24hour-cabinet',
    name: 'Mini 24-Hour Book Cabinet',
    description: 'Compact 24-hour library cabinet for indoor and outdoor placement with independent operation, identity verification, and seamless borrowing without secondary registration.',
    category: 'hardware',
    features: [
      'Indoor and outdoor placement',
      'Independent operation capability',
      'Identity verification system',
      'Seamless borrowing process',
      'No secondary registration required',
      '24-hour accessibility',
      'Compact footprint design'
    ],
    specifications: {
      'Model': 'TG001',
      'Dimensions': '1300×425×1883mm',
      'Material': 'Sheet Metal + Tempered Glass',
      'Screen': '21.5-inch Touch Screen',
      'Operation': '24-hour independent',
      'Authentication': 'Multi-method verification',
      'Weather': 'Indoor/outdoor capable'
    },
    image: productImageMap['24-hour-smart-bookcase'].image
  },
  {
    id: 'mobile-inventory-cart',
    name: 'Mobile Inventory Cart',
    description: 'Professional mobile cart for librarian inventory tasks with handheld RFID antenna, desktop reading area, mobile bookshelf, and 6+ hours continuous operation.',
    category: 'hardware',
    features: [
      'Handheld RFID antenna included',
      'Desktop reading/writing area',
      'Mobile bookshelf integrated',
      '6+ hours continuous operation',
      'Multi-book shelving support',
      'Handheld inventory scanning',
      'High-quality construction'
    ],
    specifications: {
      'Model': 'YH009',
      'Dimensions': '1208×481×503mm',
      'Material': 'Sheet Metal + Tempered Glass',
      'Screen': '21.5-inch Touch Screen',
      'Battery Life': '6+ hours continuous',
      'Mobility': 'Mobile cart with wheels',
      'RFID': 'Handheld and desktop antennas'
    },
    image: '/images/products/mobile-inventory-cart.png'
  },
  {
    id: 'self-service-search-kiosk',
    name: 'Self-Service Search Kiosk',
    description: 'Advanced search kiosk with big data system integration, library information display, and comprehensive OPAC system functionality for book searches.',
    category: 'hardware',
    features: [
      'Big data system integration',
      'Library information display',
      'OPAC system functionality',
      'Comprehensive book search',
      'Multiple screen size options',
      'Touch-optimized interface',
      'Real-time data display'
    ],
    specifications: {
      'Model': 'TG110',
      'Screen Options': '32-inch / 43-inch available',
      'Material': 'Sheet Metal + Tempered Glass',
      'Functions': 'OPAC + Big data display',
      'Installation': 'Floor or wall mounted',
      'Connectivity': 'Ethernet and WiFi',
      'Interface': 'Multi-touch capable'
    },
    image: '/images/products/self-service-search-kiosk.png'
  },
  {
    id: 'ai-digital-librarian',
    name: 'AI Digital Librarian',
    description: 'Advanced AI-powered digital librarian with large touch screen display and optional holographic chamber for next-generation library interaction.',
    category: 'hardware',
    features: [
      'AI-powered interactions',
      'Large 55-inch touch display',
      'Holographic chamber option',
      'Advanced user assistance',
      'Multi-language support',
      'Voice recognition',
      'Next-generation interface'
    ],
    specifications: {
      'Model': 'HTGY01',
      'Material': 'Sheet Metal + Tempered Glass',
      'Screen': '55-inch Touch Screen',
      'Special Features': 'Holographic Chamber Optional',
      'AI Functions': 'Natural language processing',
      'Voice': 'Speech recognition and synthesis',
      'Installation': 'Floor standing'
    },
    image: '/images/products/ai-digital-librarian-1.png'
  },
  {
    id: 'ai-inventory-robot',
    name: 'AI Inventory Robot',
    description: 'Autonomous AI robot for visual automatic inventory management with navigation capabilities and advanced book tracking functionality.',
    category: 'hardware',
    features: [
      'AI visual automatic inventory',
      'Autonomous navigation',
      'Advanced book tracking',
      'Automated route planning',
      'Real-time inventory updates',
      'Collision avoidance',
      'Remote monitoring capability'
    ],
    specifications: {
      'Model': 'ZS-IVR-002',
      'Functions': 'AI visual inventory + Navigation',
      'Automation': 'Fully autonomous operation',
      'Navigation': 'SLAM technology',
      'Vision': 'AI-powered book recognition',
      'Battery': 'Extended operation time',
      'Connectivity': 'WiFi and 4G'
    },
    image: '/images/products/ai-inventory-robot.png'
  },
  {
    id: 'book-disinfection-cabinet',
    name: 'Self-Service Book Disinfection Cabinet',
    description: 'Professional book disinfection cabinet for maintaining library hygiene with automated disinfection cycles and user-friendly operation.',
    category: 'hardware',
    features: [
      'Automated disinfection cycles',
      'UV and ozone sterilization',
      'User-friendly operation',
      'Safety-first design',
      'Efficient sterilization',
      'Multiple book capacity',
      'Hygiene maintenance'
    ],
    specifications: {
      'Model': 'MXDG3',
      'Dimensions': '650×600×1590mm',
      'Sterilization': 'UV + Ozone technology',
      'Capacity': 'Multiple books per cycle',
      'Safety': 'Automated safety locks',
      'Cycle Time': 'Optimized for efficiency',
      'Installation': 'Floor standing'
    },
    image: '/images/products/book-disinfection-cabinet.png'
  },
  {
    id: 'rfid-handheld-collector',
    name: 'RFID Handheld Data Collector',
    description: 'Professional handheld RFID data collector with 12-hour battery life and 5.2-inch touch screen for efficient mobile inventory operations.',
    category: 'hardware',
    features: [
      '12-hour battery life',
      '5.2-inch touch screen',
      'RFID data collection',
      'Portable design',
      'Real-time data sync',
      'Ergonomic handling',
      'Professional-grade performance'
    ],
    specifications: {
      'Model': 'MJ6800',
      'Battery Life': '12 hours',
      'Screen': '5.2-inch touch screen',
      'RFID': 'High-performance reader',
      'Connectivity': 'WiFi and Bluetooth',
      'Storage': 'Large data capacity',
      'Durability': 'Industrial-grade construction'
    },
    image: '/images/products/rfid-handheld-collector.png'
  },
  {
    id: 'uhf-rfid-tag',
    name: 'UHF RFID Tag',
    description: 'High-performance ultra-high frequency RFID tag specifically designed for library applications with extended read range and exceptional durability for long-term use.',
    category: 'hardware',
    features: [
      'Ultra-high frequency operation',
      'Extended 8-meter read range',
      'NXP UCODE 8/9 chip technology',
      'Compact 3×95mm antenna design',
      '100,000 write cycles durability',
      '50-year data retention',
      'Library-optimized design'
    ],
    specifications: {
      'Antenna Size': '3×95mm',
      'Chip': 'NXP UCODE 8 / NXP UCODE 9',
      'Frequency': '860-960MHz',
      'Read Range': '8 meters',
      'EPC Memory': '128Bits / 96Bits',
      'TID Memory': '96Bits',
      'Durability': '100,000 write cycles',
      'Data Retention': '50 years',
      'Application': 'Library systems'
    },
    image: '/images/products/uhf-rfid-tag.png'
  },
  {
    id: 'rfid-book-drop',
    name: 'RFID Smart Book Drop',
    description: 'RFID Smart Book Drop integrates RFID automatic identification technology with traditional book drop structure, supporting 24/7 self-service book returns. The device can automatically sense and register returned book information, upload data in real-time, greatly improving book circulation efficiency and reducing librarian workload.',
    category: 'hardware',
    features: [
      'RFID book automatic identification and registration',
      '24-hour unmanned self-service returns',
      'Compatible with traditional book drop methods',
      'Real-time data upload and remote monitoring',
      'Robust structure, mobile and convenient',
      'User-friendly interface',
      'Suitable for various libraries and public spaces'
    ],
    specifications: {
      'Model': 'BD100',
      'Dimensions': '800×600×1200mm',
      'Material': 'Steel + Aluminum + Acrylic',
      'RFID': 'HF 13.56MHz',
      'Capacity': '200+ books',
      'Power': 'AC 220V',
      'Connectivity': 'Ethernet, WiFi'
    },
    image: '/images/products/WechatIMG350.jpg'
  }
];

// 按类别分组产品
export const productsByCategory = {
  software: products.filter(p => p.category === 'software'),
  hardware: products.filter(p => p.category === 'hardware')
};

// 获取特色产品（用于首页展示）
export const featuredProducts = products.filter(p => {
  const featuredIds = ['hf-rfid-gate', 'librarian-workstation-allinone', 'uhf-rfid-gate', 'rfid-book-drop'];
  return featuredIds.indexOf(p.id) !== -1;
}); 